const supportedOsArray = ['windows', 'mac', 'linux'] as const;
export type SupportedOs = (typeof supportedOsArray)[number];

export function isSupportedOs(text: string): text is SupportedOs {
  return supportedOsArray.includes(text as any);
}
